import React from "react";

export const LandingPageMessages = {

// Main landing page card links begin

ColudInfra:`https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=cloud-infrastructure`,
CloudInfraText:`Experience onboarding your product hassle-free into Azure Cloud.`,
DevOps: `https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=azure-devops`,
DevopsText:`Facilitate engineering teams with clicks away code to deploy automation.`,
DataAccess:`https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=data-access-api`,
DataAccessText:`Rich dataset accessible with rest API. Sphere, Marketing 360, and others rely on this.`,
DataLake:`https://transport-logistics.visualstudio.com/Maestro%20Public%20Wiki/_wiki/wikis/Maestro-Public-Wiki.wiki/4016/Maestro-Portal-User-Guideline?anchor=centralized-data-lake`,
DataLakeText:`A Centeralized, managed and secure repository to store your structured and unstructured data at any scale.`,

//Main landing page card links end

  //Footer links start
  
  yammerlink:`https://www.yammer.com/maerskgroup.com/#/threads/inGroup?type=in_group&feedId=10461175808&view=all`,
  teamsite:`https://teamsite.maerskgroup.com/teams/maestro/SitePages/Maestro-Core-Engineering.aspx`,

  //footer links End
  
  navbarlink:`https://maestroplatform.azurewebsites.net/`, //nav bar home
  
  penny: `"Penny Analytics" is now called "Pricing Data Science" or "PRIDS".
    They support Revenue Managers (mainly pricing managers) to make
    better and faster pricing decisions for Maersk SPOT, positively
    impacting both revenue and profits. In addition, they work on
    price automation/recommendation which could also make the pricing
    manager much more efficient (more time to focus on other more
    complex value adding tasks)`,
  containercloud: `Container Cloud is a new platform built for giving APMT a new edge
    in commercial opportunities. It includes all the container vessels,
    their operator and service assignment across more than 640 terminals
    globally. Proprietary terminal geo-fencing through manual mapping.
    Container Cloud works by combining vessel, service and terminal
    data. Container vessel position through AIS (Automated
    Identification System) data, 5 min resolution from satellite,
    terrestrial and ship to ship AIS mesh network data. Container Cloud
    gives us data and analyses at a new scale and speed, near real time
    visibility of operating conditions, productivity and berthing
    delays, benchmarking APMT & ML operations vs terminal and carrier
    competitors.`,
  financeotc: `"Finance OTC" Order to Cash, referred to as OTC, is the end-to-end business process that provides smart data to support some area of ocean finance OTC team BAU. Include late payment fee identification, performance & transaction monitoring, receiving and processing customer orders and Financial pending task analysis.`,
  intermodal: `Intermodal Additional Charges: This workflow contains details of Intermodal Additional Charges applicable on bookings in different countries to prevent revenue leakage. Daily invoices and bills are paid to the vendor as received but sometimes, charges are not billed from the customer. This workflow is to provide the visibility of such additional charges to stop revenue leakage. Intermodal additional charges data is to be used by Customer services and intermodal users; these components do not contain any chargeback from GCSS.`,
  fmt: `The month end report is in short, a consolidated overview / dashboard, highlighting machinery related off-specs measurements made onboard.The dashboard is designed to automatically flag off-specs measurements before they turn into potential cost heavy repairs and service impacting breakdowns onboard the 300+ Maersk owned vessels. The off-spec measurements are automatically extracted and presented to 40+ superintendents (Users) who will take proper action with the vessel.`,
  mainlandingpageContent:`In our request to become the global integrator of container logistics, our data and
  analytics capabilities sit as a core pillar. Maestro is the capability that powers all data
  driven insights at Maersk. The Maestro portal will help you on your journey to use data in
  your business decissions.`,
  //commercial: `Dummy ContentDummy ContentDummy ContentDummy Content Dummy ContentDummy ContentDummy ContentDummy Content`,
  boxview: (
    <>
      <div className="pr-2">
        RA Tool is part of BoxView suite of EMR Service Delivery products. It
        consists of two sub-parts:
      </div>
      <div className="pr-2 pt-2">
        <span className="text-dark">
          <b>Repair Alerts</b>{" "}
        </span>
        - generates automatic alerts detecting anomalies in created work orders
        thereby enabling EMR teams to intervene during estimate approval process
        as well as take corrective action through vendor audits;
      </div>
      <div className="pr-2 pt-2">
        <span className="text-dark">
          <b>Shop Analysis</b>
        </span>{" "}
        - provides data insights and best-of-benchmark analysis assisting EMR
        inspectors for performance improvement discussions with repair shops
      </div>
    </>
  ),
  gcaoce: (
    <>
      <div className="pr-2">
        GCA OCE is a data tool and dashboard collection to improve work
        efficiency and data visibility for GCA CX team.
      </div>
      <div className="pr-2 pt-2">
        The GCA CBP mapping in data tool allows user to link the shipment with
        the right GCA CBP at the 1st time. And the tailor made EQU data tool can
        help the CCM team to reduce manual work and provided the transparency
        during the EQU control and release process And GCA OCE also provided the
        visibility to most frequent used dashboard for GCA CX team for data
        analysis on customer or agent level. Such as Rolling dashboard, Pending
        task/PFV dashboard.
      </div>
    </>
  ),
  mirror: (
    <>
      <div className="pr-2">
        APA Mirror provides a bird’s eye view performance of the Maersk services
        you are engaging in.
      </div>
      <div className="pr-2 pt-2">
        Maersk aims to have a proactive consultative partnership with our
        customers. Empowers logistics professionals to elevate from solving
        problems to seeking opportunities - turning supply chain management into
        a competitive advantage. The key differentiator here is we are using
        success measures that matters most to our customers. Customer and Maersk
        share the same KPIs. Presented as interactive visuals for more agile
        actionable insights and better outcomes ownership.
      </div>
    </>
  ),
};
